import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { pathOr } from 'ramda';
import { makeTitle } from 'utilities/huggg';

const hugggTitle = (isError, huggg) =>
  huggg && huggg.id && !isError ? makeTitle(huggg) : 'huggg';

const PageTitle = props => {
  const { huggg, title } = props;
  const isError = pathOr(false, ['hugggState', 'error'], window);

  return (
    <Helmet>
      <title>{title ? title : hugggTitle(isError, huggg)}</title>
    </Helmet>
  );
};

PageTitle.propTypes = {
  huggg: PropTypes.object,
  title: PropTypes.string
};

export default PageTitle;
